export default {
    bindings: {
        environmentLabel: '='
    },
    template: require('./logo.tpl.html')
};
